export const getGameClientFrame = () => {
  const gameClientFrame = document.querySelector<HTMLIFrameElement>(
    '#casino-game-client',
  );
  return gameClientFrame;
};
